import { NgModule } from '@angular/core'
import { CommonModule } from '@angular/common'
import { RuleAuthorizedDirective } from './rule-authorized.directive'
import { RuleValidateDirective } from './rule-validate.directive'



@NgModule({
  declarations: [RuleAuthorizedDirective, RuleValidateDirective],
  imports: [
    CommonModule
  ],
  exports: [
    RuleAuthorizedDirective,
    RuleValidateDirective
  ]
})
export class PermissionModule { }
